import { render, staticRenderFns } from "./newApprovalModule.vue?vue&type=template&id=eb006d42&scoped=true"
import script from "./newApprovalModule.vue?vue&type=script&lang=js"
export * from "./newApprovalModule.vue?vue&type=script&lang=js"
import style0 from "../newflows.scss?vue&type=style&index=0&id=eb006d42&prod&lang=scss&scoped=true&external"
import style1 from "./newApprovalModule.vue?vue&type=style&index=1&id=eb006d42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb006d42",
  null
  
)

export default component.exports